import { IFormInput } from '../../types';

export interface IGenderSwitch extends IFormInput {
  className?: string;
}

export enum GenderEnum {
  MALE = 'male',
  FEMALE = 'female',
  UNKNOWN = 'unknown',
}
